import React, { useEffect } from 'react';
import { StyleSheet, View, Text, ScrollView, TouchableOpacity, ActivityIndicator } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../store/slices/authSlice';
import { fetchMissions } from '../store/slices/missionSlice';
import StatsCard from '../components/dashboard/StatsCard';
import RecentMissions from '../components/missions/RecentMissions';
import RecentReports from '../components/reports/RecentReports';
import Logo from '../components/common/Logo';

const DashboardScreen = ({ navigation }) => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const { isLoading, missions } = useSelector(state => state.missions);
  
  // Cargar misiones o reportes al montar el componente
  useEffect(() => {
    // Cargar datos cada vez que se muestra la pantalla
    const unsubscribe = navigation.addListener('focus', () => {
      console.log('Cargando datos en DashboardScreen');
      console.log('Usuario actual:', user);
      
      // Para usuarios de empresa, fetchMissions cargará reportes en lugar de misiones
      // gracias a la lógica en el slice de misiones
      dispatch(fetchMissions());
    });

    return unsubscribe;
  }, [dispatch, navigation, user]);
  
  // Calcular estadísticas basadas en las misiones cargadas
  const getStats = () => {
    const isEnterpriseUser = user?.is_enterprise_user && !user?.is_pilot && !user?.is_staff;
    
    if (!missions || missions.length === 0) {
      if (isEnterpriseUser) {
        return [
          { title: 'Reportes Totales', value: 0 },
          { title: 'Completados', value: 0 },
          { title: 'Pendientes', value: 0 }
        ];
      } else {
        return [
          { title: 'Misiones Activas', value: 0 },
          { title: 'Completadas', value: 0 },
          { title: 'Pendientes', value: 0 }
        ];
      }
    }
    
    const active = missions.filter(m => m.status === 'IN_PROGRESS').length;
    const completed = missions.filter(m => m.status === 'COMPLETED').length;
    const pending = missions.filter(m => m.status === 'PENDING').length;
    
    if (isEnterpriseUser) {
      return [
        { title: 'Reportes Totales', value: missions.length },
        { title: 'Completados', value: completed },
        { title: 'Pendientes', value: pending + active }
      ];
    } else {
      return [
        { title: 'Misiones Activas', value: active },
        { title: 'Completadas', value: completed },
        { title: 'Pendientes', value: pending }
      ];
    }
  };

  const stats = getStats();

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  // Determinar el tipo de usuario para mostrar
  const getUserType = () => {
    if (user?.is_staff) return 'Admin';
    if (user?.is_pilot) return 'Piloto';
    if (user?.is_enterprise_user) return 'Usuario de Empresa';
    return '';
  };

  return (
    <ScrollView style={styles.container}>

      
      <View style={styles.header}>
        <Text style={styles.headerTitle}>{'Panel de Control'}</Text>
        <Text style={styles.welcomeText}>
          {`Bienvenido, ${user?.email || 'Usuario'}${getUserType() ? ` (${getUserType()})` : ''}`}
        </Text>
        <Text style={styles.missionCount}>
          {user?.is_enterprise_user && !user?.is_pilot && !user?.is_staff 
            ? `Reportes: ${missions ? missions.length : 0}` 
            : `Misiones: ${missions ? missions.length : 0}`}
        </Text>
      </View>
      
      <View style={styles.statsContainer}>
        {stats.map((stat, index) => {
          return (
            <StatsCard 
              key={index} 
              title={stat.title} 
              value={stat.value} 
            />
          );
        })}
      </View>
      
      {isLoading && (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size="large" color="#2c3e50" />
        </View>
      )}
      
      <View style={styles.contentContainer}>
        {user?.is_enterprise_user && !user?.is_pilot && !user?.is_staff 
          ? <RecentReports limit={5} />
          : <RecentMissions limit={5} />
        }
      </View>
      
      <TouchableOpacity style={styles.logoutButton} onPress={handleLogout}>
        <Text style={styles.logoutButtonText}>{'Cerrar sesión'}</Text>
      </TouchableOpacity>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },

  header: {
    padding: 15,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  welcomeText: {
    fontSize: 16,
    color: '#7f8c8d',
    marginTop: 5,
  },
  missionCount: {
    fontSize: 14,
    color: '#3498db',
    marginTop: 5,
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 15,
  },
  loadingContainer: {
    padding: 20,
    alignItems: 'center',
  },
  contentContainer: {
    flex: 1,
  },
  logoutButton: {
    backgroundColor: '#e74c3c',
    borderRadius: 5,
    padding: 15,
    margin: 15,
    alignItems: 'center',
  },
  logoutButtonText: {
    color: 'white',
    fontWeight: 'bold',
  },
});

export default DashboardScreen;